// webapp/src/ui/DiagBoot.tsx
import React from 'react';
import { installMessageTap } from '../lib/diag/messageTap';
import { installLayoutTap } from '../lib/diag/layoutTap';

function shouldEnableDiag(): boolean {
  if (typeof window === 'undefined') return false;
  const diagWindow = window as Window & {
    __DIAG__?: number;
    __PROFILE_EVENTS__?: string;
    __NET_TAP__?: number;
  };

  // 1) URL switch ?diag=1 sets/persists flag
  const qs = new URLSearchParams(window.location.search);
  if (qs.get('diag') === '1') {
    try { window.localStorage.setItem('__diag__', '1'); } catch {}
    return true;
  }
  if (qs.get('diag') === '0') {
    try { window.localStorage.removeItem('__diag__'); } catch {}
    return false;
  }

  // 2) Persisted flag
  try { if (window.localStorage.getItem('__diag__') === '1') return true; } catch {}

  // 3) Env toggle (Vercel Preview: set NEXT_PUBLIC_DIAG=1)
  // Also allow console toggle: window.__DIAG__ = 1
  if (process.env.NEXT_PUBLIC_DIAG === '1' || diagWindow.__DIAG__ === 1) return true;

  return false;
}

export default function DiagBoot() {
  React.useEffect(() => {
    if (typeof window === 'undefined') return;
    const enabled = shouldEnableDiag();
    if (!enabled) return;

    const diagWindow = window as Window & { __PROFILE_EVENTS__?: string; __NET_TAP__?: number };
    // Ensure other gated instruments also run in production preview
    diagWindow.__PROFILE_EVENTS__ = '1'; // enables perfGuards
    diagWindow.__NET_TAP__ = 1;          // enables netTap

    try {
      // Hot window taps: message handlers + layout read stacks
      installMessageTap({ minDurationMs: 32, includeRegisterStack: true, includeInvokeStack: false });
      installLayoutTap({ windowMs: 1200, minCount: 4, maxStacks: 6 });
      // eslint-disable-next-line no-console
      console.warn('[diag] instrumentation enabled (url/localStorage/env)');
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error('[diag] failed to install', e);
    }
  }, []);

  return null;
}
